import { IBlock, IDynamicBlock } from 'common/builder/blocks/blockInterfaces'
import {
  BlockConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { getButtonsFromMap } from 'common/builder/components/chart/FlowChart/lib/utils/getButtonsFromMap'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { FlowChartDynamicBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartDynamicBlock'
import { BlockType } from 'common/builder/constants/BlockType'

export const DynamicBlockGenericConverterRule: ConverterRule<
  IDynamicBlock,
  FlowChartDynamicBlock,
  BlockConverterRulePayload
> = {
  predicate: (entity: IBlock) => entity?.type === BlockType.DYNAMIC,
  convert: (entity: IDynamicBlock, { fields, flowChartButtons }) => ({
    id: entity.id,
    type: FlowChartBlockType.DYNAMIC,
    data: {
      url: entity.url ? replaceFieldsInString(entity.url, fields) : null,
      fallback: getButtonsFromMap(entity.buttons, flowChartButtons)[0] || null,
    },
  }),
}
